export enum PriceAvailabilityRequestStatus {
    OPEN = 'OPEN',
    FULL_AVAILABILITY = 'FULL_AVAILABILITY',
    PARTIAL_AVAILABILITY = 'PARTIAL_AVAILABILITY',
    CANCELED = 'CANCELED',
}
